var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 17.8327C1.875 18.454 2.37868 18.9577 3 18.9577H7.83333C8.45465 18.9577 8.95833 18.454 8.95833 17.8327V14.666C8.95833 14.0447 8.45465 13.541 7.83333 13.541H3C2.37868 13.541 1.875 14.0447 1.875 14.666V17.8327ZM3.125 17.7077V14.791H7.70833V17.7077H3.125Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45833 5.33268C6.45833 5.954 6.96201 6.45768 7.58333 6.45768H12.4167C13.038 6.45768 13.5417 5.954 13.5417 5.33268V2.16602C13.5417 1.5447 13.038 1.04102 12.4167 1.04102H7.58333C6.96201 1.04102 6.45833 1.5447 6.45833 2.16602V5.33268ZM7.70833 5.20768V2.29102H12.2917V5.20768H7.70833Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0417 17.8327C11.0417 18.454 11.5453 18.9577 12.1667 18.9577H17C17.6213 18.9577 18.125 18.454 18.125 17.8327V14.666C18.125 14.0447 17.6213 13.541 17 13.541H12.1667C11.5453 13.541 11.0417 14.0447 11.0417 14.666V17.8327ZM12.2917 17.7077V14.791H16.875V17.7077H12.2917Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79167 11.2493V14.166H6.04167V11.2493C6.04167 10.6741 6.50804 10.2077 7.08333 10.2077H12.9167C13.492 10.2077 13.9583 10.6741 13.9583 11.2493V14.166H15.2083V11.2493C15.2083 9.9837 14.1823 8.95768 12.9167 8.95768H7.08333C5.81768 8.95768 4.79167 9.9837 4.79167 11.2493Z",
    fill: "#656579"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 5.83268V9.58268H10.625V5.83268H9.375Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkAlt);
export default __webpack_public_path__ + "static/media/network-alt.99fc37759cadfabe0ce45b6a39723d0b.svg";
export { ForwardRef as ReactComponent };